// extracted by mini-css-extract-plugin
module.exports = {"imgMap":"Map_imgMap__GqJg7"};